import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import { emitter } from '@/plugins/emitter'

type HostVm = {
  $globalVar: { isYagiPrime: boolean; in_app_payments: boolean }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AiReasonBnr',
  setup(__props) {

const route = useRoute()
const vm = getCurrentInstance()!.proxy as unknown as HostVm
const globalVar = vm.$globalVar
const showRandomly = ref(Math.random() < 0.7)

const bannerType = computed(() => {
  const currentPath = route.path
  if (/^\/format\/[^/]+\/edit\/reason$/.test(currentPath)) return 'reason'
  if (/^\/format\/[^/]+\/edit\/id-photo$/.test(currentPath)) return 'id-photo'
  return null
})

const title = computed(() =>
  bannerType.value === 'reason'
    ? '志望動機で手が止まっていませんか？'
    : '背景、そのままになっていませんか？'
)

const description = computed(() =>
  bannerType.value === 'reason'
    ? 'AIアシスタントが作成をサポートします'
    : '自撮り写真をアップロードするだけで背景を証明写真風に自動調整できます'
)

const shouldShowBanner = computed(() => {
  if (globalVar.isYagiPrime) return false
  if (!bannerType.value) return false
  return showRandomly.value
})

function closeBtn() {
  const element = document.querySelector('.ai-reason-bnr') as HTMLElement | null
  if (element) element.style.display = 'none'
}

function handleBannerClick() {
  if (bannerType.value === 'reason') {
    emitter.emit('open-ai-reason-dialog')
  } else if (bannerType.value === 'id-photo') {
    emitter.emit('open-idphoto-prime-dialog')
  }
}

return { __sfc: true,route, vm, globalVar, showRandomly, bannerType, title, description, shouldShowBanner, closeBtn, handleBannerClick }
}

})